import React from 'react';
import cx from 'classnames';
import styles from './ButtonRenderer.module.less';
import { Button, ButtonVariantStyle, Icon } from '@paypalcorp/pp-react';
import { useNavigate } from 'react-router';
import { trackButtonClick } from '../../lib/fpti';
import isAbsolutePath from '../../util/isAbsolutePath';

interface EcmButtonProps {
  buttonLabel: string;
  buttonType: string;
  buttonLink: string;
  size: string;
  iconComponent: string;
  iconColor?: string;
  styles?: React.CSSProperties;
}

interface ButtonRendererProps {
  ecmContent: EcmButtonProps;
  className?: string;
}

const ButtonRenderer: React.FC<ButtonRendererProps> = ({ ecmContent }) => {
  const {
    buttonLabel,
    buttonType,
    buttonLink,
    size,
    iconComponent,
    iconColor,
    styles: customStyles
  } = ecmContent;
  const navigate = useNavigate();

  const handleNavigation = (url: string) => {
    if (isAbsolutePath(url)) {
      if (url.includes('/studio')) {
        window.open(url, '_self', 'popup=false');
      } else {
        window.open(url);
      }
    } else {
      navigate(url);
    }
  };

  return (
    <div className={styles.button_container} style={{ ...customStyles }}>
      <Button
        className={cx(styles.button, styles[buttonType.toLowerCase()])}
        size={size}
        variant={buttonType.toLowerCase() as ButtonVariantStyle}
        onClick={() => {
          trackButtonClick(buttonLabel, buttonLink);
          handleNavigation(buttonLink);
        }}
      >
        {iconComponent && (
          <div
            className={styles.icon_container}
            style={
              iconColor ? ({ '--custom-background': iconColor } as React.CSSProperties) : undefined
            }
          >
            {iconComponent.startsWith('http') ? (
              <img
                src={iconComponent}
                alt={`${buttonLabel} Icon`}
                className={cx(styles.image_section, styles.customBackground)}
                loading="lazy"
              />
            ) : (
              <Icon
                name={iconComponent}
                size={size as 'sm' | 'lg'}
                className={cx(styles.icon_section, styles.customBackground)}
              />
            )}
          </div>
        )}
        {buttonLabel}
      </Button>
    </div>
  );
};

export default ButtonRenderer;
